export const PROD_APP_ID = 'on59wxro'
export const STAGING_OR_DEV_APP_ID = 'ovthknzg'
